import G6 from '@antv/g6';
import isArray from 'lodash/isArray';
import CommandManager from '../commands/CommandManager';
import { EditorCommand, GraphCanvasEvent, GraphCommonEvent, ItemType } from '../constants';
import { Behavior, GraphEvent, Group, Shape } from '../types';
import { getGlobal, guid } from '../utils';

export const DRAG_ADD_NODE_DEFAULT_SIZE = 100;

interface DragAddNodeBehavior extends Behavior {
  shape: Shape | null;
  handleCanvasMouseEnter(e: GraphEvent): void;
  handleMouseMove(e: GraphEvent): void;
  handleMouseUp(e: GraphEvent): void;
}

const dragAddNodeBehavior: DragAddNodeBehavior = {
  shape: null,

  getEvents() {
    return {
      [GraphCanvasEvent.onCanvasMouseEnter]: 'handleCanvasMouseEnter',
      [GraphCommonEvent.onMouseMove]: 'handleMouseMove',
      [GraphCommonEvent.onMouseUp]: 'handleMouseUp',
    };
  },

  handleCanvasMouseEnter(e) {
    const { graph, shape } = this;

    if (shape) return;

    const global = getGlobal(graph);
    const { model } = global.component.itemPanel;

    if (!model) return;

    const { size = DRAG_ADD_NODE_DEFAULT_SIZE } = model;

    let width = 0;
    let height = 0;

    if (isArray(size)) {
      [width, height] = size;
    } else {
      width = size;
      height = size;
    }

    const x = e.x - width / 2;
    const y = e.y - height / 2;
    const group: Group = graph?.get('group');

    this.shape = group.addShape('rect', {
      className: global.component.itemPanel.delegateShapeClassName,
      attrs: {
        x,
        y,
        width,
        height,
        fill: '#f3f9ff',
        fillOpacity: 0.5,
        stroke: '#1890ff',
        strokeOpacity: 0.9,
        lineDash: [5, 5],
        cursor: 'grabbing',
      },
    });
    graph?.paint();
  },

  handleMouseMove(e) {
    const { graph } = this;
    const { width, height } = this.shape?.getBBox();

    const x = e.x - width / 2;
    const y = e.y - height / 2;
    this.shape?.attr({ x, y });
    graph?.paint();
  },

  handleMouseUp(e) {
    const { graph } = this;

    const { width, height } = this.shape?.getBBox();
    const global = getGlobal(graph);

    let { x } = e;
    let { y } = e;

    const { model } = global.component.itemPanel;
    if (model?.center === 'topLeft') {
      x -= width / 2;
      y -= height / 2;
    }
    this.shape?.remove(true);
    const commandManager: CommandManager = graph?.get('commandManager');
    commandManager.execute(graph, EditorCommand.Add, {
      type: ItemType.Node,
      model: { id: guid(), x, y, ...model },
    });
  },
};

G6.registerBehavior('drag-add-node', dragAddNodeBehavior);
